import * as Sort   from '../../../../components/blocks/sort/main';
import {SearchUrl} from './partner-search-url';


export function init(searchUrl: SearchUrl) {

  const mainElm           = document.querySelector('#block-system-main')          as HTMLElement;
  const sortWidgetElm     = document.querySelector('.sort')                       as HTMLElement;
  
  // Update search url if a sort checkbox has been selected.
  mainElm.addEventListener('sortCheckboxEvent', ((event: CustomEvent) => {
  
    const status = event.detail.status as 'init' | boolean;
  
    searchUrl.sortOrder = 
      (status === true || status === 'init') ? event.detail.parameter : '';
  
    if (status === true) {
      window.location.href = searchUrl.getUrl()
    }
  }) as EventListener);
  
  
  // Init sort widget
  Sort.init(sortWidgetElm);
}
